module.exports = ".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: overlay;\n  outline: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/controls/spk-modal-lookup/spk-modal-lookup.component.scss
// module id = ./src/app/components/framework/spk/controls/spk-modal-lookup/spk-modal-lookup.component.scss
// module chunks = main